module.exports = __webpack_public_path__ + "static/media/Drawdown6MakingItHappen.bb81bada.jpg";